import React from "react";
import { images } from "../../constants";
import "./Header.css";

const Header = () => (
    <div className="app__header app__bg  section__padding" id="home">
        <div className="xx">
            <div id="contain">
                <img src={images.a} alt="header_img" />
            </div>
            <div className="app__header-logoo">
                <img src={images.logoo} alt="app__logo" />
            </div>

            <h2 className="head-textt">
                NAUCZĘ CIĘ JAK <br />
                <span className="green">ŚWIADOMIE</span> TRENOWAĆ <br /> I JAK ZMIENIĆ NAWYKI{" "}
                <br /> ŻYWIENIOWE
            </h2>

            <div className="divv" />
        </div>
    </div>
);

export default Header;
